module.exports = __webpack_public_path__ + "static/img/gp.1ebed18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/gp.png
// module id = uwLo
// module chunks = 0